import { render, staticRenderFns } from "./spinner_big.vue?vue&type=template&id=06cef5de&scoped=true&"
import script from "./spinner_big.vue?vue&type=script&lang=js&"
export * from "./spinner_big.vue?vue&type=script&lang=js&"
import style0 from "./spinner_big.vue?vue&type=style&index=0&id=06cef5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cef5de",
  null
  
)

export default component.exports